import React, { useEffect } from "react";
import { useMediaQuery, useTheme } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setBreakpoint, setDeviceType, setResolution } from '../../store/slices/configSlice';


const Screen = () => {
    const dispatch = useDispatch();

    //CALCULATE THE SCREEN SIZE 
    //==============================================================================
    const theme = useTheme();
    const isSXS = useMediaQuery(theme.breakpoints.down('xs')); 
    const isXS = useMediaQuery(theme.breakpoints.down('sm')); 
    const isSM = useMediaQuery(theme.breakpoints.down('md')); 
    const isMD = useMediaQuery(theme.breakpoints.down('lg')); 
    const isLG = useMediaQuery(theme.breakpoints.down('xl'));

    // console.log(theme.breakpoints.down('sm'));
    // console.log(useMediaQuery(theme.breakpoints.down('xs')));
    
    // console.log(theme);
    // console.log(useMediaQuery());
    
    

    let breakpoint = 'xl';
    if (isSXS) breakpoint = 'sxs';
    else if (isXS) breakpoint = 'xs';
    else if (isSM) breakpoint = 'sm';
    else if (isMD) breakpoint = 'md';
    else if (isLG) breakpoint = 'lg';

    const resolution = window.screen.width;

    let deviceType = 'laptop';
    switch(breakpoint){
        case "sxs":
            deviceType = "minicell";
            break;
        case "xs":
            deviceType = "cell";
            break;
        case "sm":
            deviceType = "tablet";
            break;
        case "md":
            deviceType = "laptop";
            break;
        case "lg":
            deviceType = "laptop";
            break;
        case "xl":
            deviceType = "laptop";
            break;
    }
    //==============================================================================


    useEffect(() => {
        dispatch(setBreakpoint(breakpoint));
        dispatch(setDeviceType(deviceType));
        dispatch(setResolution(resolution));
    }, [window.screen.width]);
    
    return null
}

export default Screen;